<sticky-free [stickyId]="'listing-filters'"
             [style.z-index]="10"
             [order]="10"
             class="pos-relative _sticky">
    @if (listing) {
    <div
         class="w-12 bg-col-w wrap-l wrap-x p-l-2-s p-r-2-s p-l-2-m p-r-2-m p-t p-b p-t-2-s p-b-2-s p-t-2-m p-b-2-m inline-flex flex-middle">
        <!-- filters desktop -->
        <div class="w-12 bg-col-w flex flex-reverse-s flex-reverse-m flex-middle flex-justify-between">
            <div class="flex">
                @if(client.isX || client.isL) {
                @if(listing.sort){
                <listing-sort class="m-r-2 pos-relative _tool-button"
                              [sort]="$any(listing.sort)" />
                }
                }

                <ng-container *ifSize="'XL'">
                    @for (filter of getFiltersForChips(); track listing.filterTrackByFn($index, filter)) {
                    <button type="button"
                            (click)="showFiltersModal(filter)"
                            class="flex flex-middle b-a b-col-1 p-a-2 m-r-2 _tool-button"
                            style="border-radius: 12px;">
                        <span class="s1 s2-s s2-m">{{filter?.['attribute']?.data?.label || ''}}</span>
                        @if (getSelectedOptionsCount(filter)) {
                        <div class="m-l-1 b-radius-max bg-col-62 col-1 center"
                             style="width: 20px; height: 20px;">
                            <p class="s2">{{getSelectedOptionsCount(filter)}}</p>
                        </div>
                        }
                    </button>
                    }
                </ng-container>

                @if (listing.getFiltersWithMatches().length) {
                <button type="button"
                        class="flex flex-middle b-a b-col-1 p-a-2 _tool-button"
                        style="border-radius: 12px;"
                        (click)="showFiltersModal()">
                    <i class="icon-filter m-r-1 icon-medium"></i>
                    <span class="s1 s2-s s2-m">{{client.sizeId > 1 ? 'All Filters' : 'Filters' | translate }}</span>
                    @if (listing.isFiltered()) {
                    <div class="m-l-1 b-radius-max bg-col-62 col-1 center"
                         style="width: 20px; height: 20px;">
                        <p class="s2">{{listing.filterSelection.length}}</p>
                    </div>
                    }
                </button>
                }

                @if(listing.filterSelection.length && client.sizeId > 1){
                <button type="button"
                        class="m-l-2 flex flex-middle"
                        (click)="listing.resetFilters()">
                    <i class="icon-close m-r-1 icon-medium"></i>
                    <span class="p1">{{'Clear filters' | translate}}</span>
                </button>
                }

            </div>
            <!-- number of items -->
            <p class="s1 col-1">
                {{ '% / % results'
                | translate : listing.visibleQty : listing.getTotal()}}
            </p>
        </div>
    </div>
    }

</sticky-free>